import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    reservation: {
      code: null,
      ic_num: null
    }
  },
  mutations: {
    saveReservation(state, payload) {
      state.reservation = payload.data;
    }
  },
  actions: {

  }
})
